/*
defines appearance of connector (small text) nodes
 */

import NodeView from './node';
import WikiNodeView from './wikiNode';

/**
 * Represents a view for a connector node
 */
export default class ConnectorNodeView extends WikiNodeView {
    /**
     * makes a new connector node view
     * given a connector model node and a position
     * @param {ConnectorNode} node the model node to use
     * @param {number} [x] (optional) position to start at
     * @param {number} [y] (optional) position to start at
     */
    constructor(node, x = 0, y = 0) {
        super(node, x, y);
        this.type = 'connector';
        this.width = 128;
        this.height = 25;
        this.text = this.node.text;

        this.init();

        console.log(`new node view ${this.node.id} of type ${this.type}`);
    }

    /**
     * initializes this node with text and the correct position and shape
     */
    init() {
        let text = this.node.text;
        this.selection =
            NodeView.container.select(`.node-${this.id}`)
                .attr('fill', 'white')
                .text(text)
                .attr('width', this.width)
                .attr('height', this.height)
                .style('transform', `translateX(${-64}px) ` +
                                    `translateY(${-this.height/2}px)`)
                .style('overflow', 'visible');
    }

    /**
     * needs no updating
     */
    defineUpdateCallback() {
        // nothing
    }

    /**
     * no tooltip for connectors
     * @param {Selection} tooltip the d3 selection of the tooltip element
     */
    showTooltip(tooltip) {
    }

    /**
     * given an index, returns the color of the text
     * @param {number} i the id of this node
     * @return {string} the color to fill this node /its text with
     */
    fill(i) {
        return 'white';
    }

    /**
     * gets the svg element for this node
     * @return {SVGElement} the element to represent this node
     */
    append() {
        let fo = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        fo.setAttribute('height', 16);
        fo.setAttribute('fill', 'white');
        fo.style.transform = `translateX(${-64}px) ` +
                             `translateY(${-this.height/2}px)`;
        fo.style.overflow = 'visible';
        // var div = document.createElement('div');
        fo.innerHTML = this.node.text;
        // div.classList = 'text';
        // fo.appendChild(div);
        return fo;
    }
}
